
const ApiBaseUrl = process.env.REACT_APP_API_URL || '';

export default function readTenantCodeFromUrl() {
    const subDomainName = getSubdomain().toLowerCase();
    const indx = subDomainName.lastIndexOf("-dev");
    if (indx != -1) {
        return subDomainName.substring(0, indx)
    }
    return subDomainName;
}

function getSubdomain() {
    const hostname = window.location.hostname;
    if (hostname == 'localhost') return process.env.REACT_APP_LOCALHOST_TENANT_CODE;
    var regexParse = new RegExp('[a-z\-0-9]{2,63}\.[a-z\.]{2,5}$');
    var urlParts = regexParse.exec(hostname);
    console.log(hostname);
    return hostname.replace(urlParts[0], '').slice(0, -1);
}